import React, { useState } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../../styles.module.scss'
import EmptyCard from '../../common/EmptyCard'
import Avatar from 'srcReact/components/common2/Avatar'
import { useTranslation } from 'react-i18next'
import { formatLastUpdateDate } from 'srcReact/helpers/datetimeHelper'
import { useSelector } from 'react-redux'
import PostFeedModal from 'srcReact/components/popinsContent/PostFeedModal'

function WhatsNew({ newData, loading, showUserLightModal, isExpanded }) {
  const { t } = useTranslation()
  const [isPostModalOpen, setIsPostModalOpen] = useState(false)

  const {
    dashboardDetail: { data: { group_id, group_name, group_info: { cover_photo, newsfeed_id } = {} } = {} } = {}
  } = useSelector((state) => state)

  const showPostModal = () => {
    setIsPostModalOpen(true)
  }
  const closePostModal = () => {
    setIsPostModalOpen(false)
  }

  const getNewsType = (type, name, count, mixrName) => {
    switch (type) {
      case 'new_picture':
        return t('dashboard.post.newPicture', {
          name,
          count
        })
      case 'new_comment':
        return t('dashboard.post.newComment', { name })
      case 'new_mixr':
        return t('dashboard.post.newMixr', { mixrName })
      case 'new_participant':
        return t('dashboard.post.newPartcipant', { mixrName })
      case 'user_join':
        return t('dashboard.post.userJoin', { name })
      case 'first_comment':
        return t('dashboard.post.firstComment', { name })
      case 'suggested_mixr':
        return t('dashboard.post.suggestedMixr', { name })
      default:
        return ''
    }
  }

  return (
    <div className={`${parentStyles.card} ${styles.whatsnew} ${isExpanded && styles.isExpanded}`}>
      {loading ? (
        <div className={styles.list}></div>
      ) : newData?.length > 0 ? (
        <React.Fragment>
          <div className={styles.list}>
            {newData.map((newItem, index) => {
              return (
                <div
                  key={`${newItem.user_info.id}${index}`}
                  className={styles.listItem}
                  onClick={() => {
                    window.location = newItem.url
                  }}>
                  <Avatar
                    userId={newItem.user_info.id}
                    firstname={newItem.user_info.firstname}
                    lastname={newItem.user_info.lastname}
                    profilePicture={newItem.user_info.profile_picture_data.profile_picture}
                    imgWrapperSize='xsmall'
                    mimeType={newItem.user_info.profile_picture_data.mime_type}
                    originalTag={newItem.user_info.profile_picture_data.original_tag}
                    isOriginal={newItem.user_info.profile_picture_data.is_original}
                    onClickAction={() => showUserLightModal(newItem.user_info)}
                    withExpertiseGroup={newItem.user_info.with_expertise_group}
                  />
                  <div className={styles.rightSection}>
                    <p className={styles.time}>{formatLastUpdateDate(newItem.date_time, '', t)}</p>
                    <p className={styles.text}>
                      {getNewsType(
                        newItem.data_type,
                        `${newItem.user_info.firstname} ${newItem.user_info.lastname?.charAt(0)}.`,
                        newItem.pictures_count,
                        newItem.mixr_name
                      )}
                    </p>
                  </div>
                  <br />
                </div>
              )
            })}
          </div>
        </React.Fragment>
      ) : (
        <EmptyCard
          contentTitle={t('dashboard.activateCommunity.titleBox')}
          contentText={t('dashboard.activateCommunity.title')}
          contentButton={t('global.writePost')}
          contentButtonAction={showPostModal}
        />
      )}
      {isPostModalOpen && (
        <PostFeedModal
          newsfeedId={newsfeed_id}
          isModalOpen={isPostModalOpen}
          closeModal={closePostModal}
          objectId={group_id}
          objectName={group_name}
          objectPicture={cover_photo}
          objectType='group'
          showSuccessBanner={true}
          showGroupInfoBanner={true}
        />
      )}
    </div>
  )
}

export default WhatsNew
